import {LocalizedText} from './localized-text';

export class MonthInfo {
  constructor(public memberInternalKey?: string,
              public monthUnemployment?: string,
              public docRegion?: string,
              public mpai?: string,
              public regionName?: LocalizedText[]) {}
}
